<template>
    <div>
        <div style="width: 100%;text-align: center;">
            <div id="wx_login_container" ref="wxqrcode" style="display: inline-block;margin-top: 10px;"></div>
        </div>
         <div style="margin-bottom:10px;display: block;text-align: center;">请及时关注微信公众号“众智云擎税法检索”</div>
        <scriptLink />
    </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
import store from '../../store/'
// import QRCode from 'qrcodejs2'
import ConstJson from "../../api/common/constjson.js"
let constJ = new ConstJson()
export default {
    name: 'wechatlogin',
    data() {
        return {

        }
    },
    components: {
        'scriptLink': {
            render(createElement) {
                return createElement(
                    'script', {
                        attrs: {
                            type: 'text/javascript',
                            src: 'https://res.wx.qq.com/connect/zh_CN/htmledition/js/wxLogin.js',
                        },
                    },
                )
            }
        }
    },
    methods: {
        //解析URL,返回URL参数对象
        getUrlkey(url) {
            console.log(url)
            var params = {};
            var urls = url.split("?");
            //console.log('1_分割url:', urls)
            var arr = urls[1].split("&");
            //console.log('2_分割urls[1]:', arr)
            console.log(arr)

            for (var i = 0, l = arr.length; i < l; i++) {

                //去除#号部分
                var a = arr[i].split("=");
                //console.log('3_遍历 arr 并分割后赋值给a:', a[0], a[1])

                //去除值的#号部分
                params[a[0]] = a[1].split('#')[0];
                //console.log('4_a给params对象赋值:', params)
            }
            //console.log('5_结果:', params)
            return params;
        },


        qrCode(url) {
            let qrcode = new QRCode('qrcode', {
                width: 100, //图像宽度
                height: 100, //图像高度
                colorDark: "#000000", //前景色
                colorLight: "#ffffff", //背景色
                typeNumber: 4,
                correctLevel: QRCode.CorrectLevel.L //容错级别 容错级别有：（1）QRCode.CorrectLevel.L （2）QRCode.CorrectLevel.M （3）QRCode.CorrectLevel.Q （4）QRCode.CorrectLevel.H
            })

            qrcode.clear() //清除二维码 
            qrcode.makeCode(url) //生成另一个新的二维码
        },

        getWXUrl() {
            //console.log(this.$baseConfig.wxRedirectUrl)
            let po = {
                //http_redirct: 'http://test0.holywiser.com/home',
                http_redirct: this.$baseConfig.wxRedirectUrl,
            }
            var customeStyle = "data:text/css;base64,QGNoYXJzZXQgIlVURi04IjsKLmltcG93ZXJCb3ggLnFyY29kZSB7IHdpZHRoOiAxNjBweDsgaGVpZ2h0OjE2MHB4O21hcmdpbi10b3A6IDE1cHg7IGJvcmRlcjogMXB4IHNvbGlkICNFMkUyRTI7fQoubG9naW5QYW5lbCAudGl0bGUge2ZvbnQtc2l6ZToxMnB4O2Rpc3BsYXk6bm9uZTt9Ci5sb2dpblBhbmVsIC5pbmZvIHtmb250LXNpemU6MTJweDt9Cg==";
            console.log('getWXUrl======================>')
            constJ.reqWXUrl(po).then(res => {
                console.log(res)
                let urlData = this.getUrlkey(res.item.url)
                console.log(urlData)
                var obj = new WxLogin({
                    self_redirect: false,
                    id: "wx_login_container",
                    appid: urlData.appid,
                    scope: urlData.scope,
                    redirect_uri: urlData.redirect_uri,
                    state: urlData.state,
                    style: "",
                    href: customeStyle, //"https://test.holywiser.com/pubcss/qr.css", //customeStyle,//
                });
                var qrcodeBox = document.getElementById("wx_login_container");
                var iframes = qrcodeBox.getElementsByTagName("iframe");
                var ifr = iframes[0]
                ifr.setAttribute("height", "260px;");
                ifr.setAttribute("width", "300px");
                //console.log(iframes[0])

            })


            // document.getElementById('qrcode').getElementsByTagName("iframe").width="100px"
            // document.getElementById('qrcode').getElementsByTagName("iframe").height="100px"
            //console.log(document.getElementById('qrcode').getElementsByTagName("iframe")) 
        },
        wexinLogin() {
            console.log('weixin login===>')
            //this.isShowQrcode = true
            //this.$refs.qrcode.innerHTML=''
            //document.getElementById('qrcode').innerHTML = ''
            this.getWXUrl()
        },
    }
}
</script>
<style>
</style>